/**
 * CookieBanner — GDPR-compliant cookie consent bar.
 * Appears 900ms after first visit, dismissed via localStorage.
 * Extracted from App.js (P3-2 refactor).
 */
import React, { useState, useEffect } from "react";

const CookieBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => {
      if (!localStorage.getItem("ti_cookie_consent")) setVisible(true);
    }, 900);
    return () => clearTimeout(t);
  }, []);

  if (!visible) return null;

  const accept = () => {
    localStorage.setItem("ti_cookie_consent", "1");
    setVisible(false);
  };

  return (
    <div
      data-testid="cookie-banner"
      style={{
        position: "fixed", bottom: 0, left: 0, right: 0, zIndex: 9999,
        background: "rgba(19, 22, 23, 0.96)",
        backdropFilter: "blur(14px)",
        borderTop: "1px solid rgba(0, 104, 116, 0.35)",
        padding: "13px 24px",
        display: "flex", alignItems: "center", justifyContent: "space-between",
        gap: 16, flexWrap: "wrap",
        animation: "ti-slide-up 0.28s ease",
        fontFamily: "'Space Grotesk', sans-serif",
      }}
    >
      <style>{`@keyframes ti-slide-up{from{transform:translateY(100%);opacity:0}to{transform:translateY(0);opacity:1}}`}</style>
      <p style={{ margin: 0, fontSize: 12.5, color: "#8a9ea2", lineHeight: 1.55, maxWidth: 640 }}>
        This site uses PostHog and Google Analytics (with IP anonymization) to understand how visitors use the service. No advertising cookies.{" "}
        <a href="/privacy" style={{ color: "#006874", textDecoration: "underline" }}>Privacy Policy</a>
      </p>
      <button
        data-testid="cookie-accept-btn"
        onClick={accept}
        style={{
          padding: "7px 20px", borderRadius: 99, border: "none",
          background: "#006874", color: "#fff",
          fontSize: 12.5, fontWeight: 600, cursor: "pointer",
          fontFamily: "'Space Grotesk', sans-serif", whiteSpace: "nowrap", flexShrink: 0,
          transition: "background 0.15s",
        }}
        onMouseEnter={e => { e.currentTarget.style.background = "#004f58"; }}
        onMouseLeave={e => { e.currentTarget.style.background = "#006874"; }}
      >
        Got it
      </button>
    </div>
  );
};

export default CookieBanner;
